"use client";

import React, { useEffect, useState } from "react";
import { useTheme } from "@/app/theme-provider";
import useFetch from "@/app/useFetch";
import Pegination from "./Pegination";
import Loader from "./Loader";

const CasestatPage = () => {
  const { language } = useTheme();

  // STATE
  const [years, setYears] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);

  // FETCH HOOK (Always place hooks at TOP)
  const { data: list, totalPages, loading, error } = useFetch(
    "/website/general-information-casestatistics",
    { page: currentPage, limit: limit },
    [currentPage, limit]
  );

  // ALWAYS make list safe
  const safeList = Array.isArray(list) ? list : [];

  // Extract UNIQUE years once data arrives
  useEffect(() => {
    if (!Array.isArray(safeList)) return;

    const allYears = Array.from(
      new Set(
        safeList.flatMap((item) =>
          Array.isArray(item?.data)
            ? item.data.map((d) => d.year)
            : []
        )
      )
    ).sort();

    setYears(allYears);
  }, [safeList]);

  // HANDLE PAGE CHANGE
  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // CONDITIONAL RETURNS (After all hooks)
  if (loading) return <Loader n={24} f={0.3} />;

  if (error)
    return (
      <section className="mt-40">
        Error loading data: {error.message || "Unexpected error occurred"}
      </section>
    );

  return (
    <>
      <section className="mt-4">
        <div className="table-responsive tenders-table">
          <table className="table table-bordered text-center align-middle statics-table">
            <thead className="thead-dark">
              <tr>
                <th scope="col">
                  {language === "en" ? "Sl No." : "ക്രമം നമ്പർ"}
                </th>
                <th scope="col">
                  {language === "en"
                    ? "CRIME STATISTICS"
                    : "കുറ്റകൃത്യ കണക്ക്"}
                </th>

                {years.map((year) => (
                  <th key={year}>{year}</th>
                ))}
              </tr>
            </thead>

            <tbody>
              {safeList.length > 0 ? (
                safeList.map((stat, index) => (
                  <tr key={stat.crime_statistic_id || index}>
                    <td>{index + 1}</td>
                    <td>{stat.crime_statistic_name}</td>

                    {years.map((year) => {
                      const yearData =
                        stat?.data?.find((d) => d.year === year) || null;

                      return <td key={year}>{yearData ? yearData.value : "-"}</td>;
                    })}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={years.length + 2}>No data available</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <Pegination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </section>
    </>
  );
};

export default CasestatPage;
